module.exports = __webpack_public_path__ + "static/media/sending-linkedin-messages-9.bd1b0047.gif";